/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AIClassification = {
  readonly id?: number;
  file: number;
  document_reference?: number | null;
  model?: AIClassification.model;
  classification_target?: AIClassification.classification_target;
  /**
   * The classification result (e.g., CAP_TABLE, BALANCE_SHEET)
   */
  classification_result: string;
  /**
   * Confidence score between 0.0 and 1.0
   */
  confidence?: number;
  /**
   * Array of commentary notes: [{category: NOTE|WARNING|INFO, content: string (max 64 chars)}]
   */
  commentary?: any;
  readonly commentary_display?: string;
  /**
   * Whether this classification has been approved by a user
   */
  is_approved?: boolean;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace AIClassification {
  export enum model {
    GPT_5 = 'gpt-5',
    GPT_5_MINI = 'gpt-5-mini',
    GPT_5_NANO = 'gpt-5-nano',
  }
  export enum classification_target {
    DOCUMENT_SECONDARY = 'DOCUMENT_SECONDARY',
    DOCUMENT_PRIMARY = 'DOCUMENT_PRIMARY',
  }
}

